import { render, staticRenderFns } from "./SecondReportSection.vue?vue&type=template&id=3bec0fa6&"
import script from "./SecondReportSection.vue?vue&type=script&lang=js&"
export * from "./SecondReportSection.vue?vue&type=script&lang=js&"
import style0 from "./SecondReportSection.vue?vue&type=style&index=0&id=3bec0fa6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports